import { createContext, useContext, useEffect, useMemo, useState } from "react";
import api from "@/lib/api";
import { SITE } from "@/siteConfig";

const SiteContext = createContext(null);

// Server-stored overrides (edited in /admin) hold the full content tree and
// merge over the config file.
export const SiteProvider = ({ children }) => {
    const [server, setServer] = useState(null);

    useEffect(() => {
        api.get("/content")
            .then((r) => setServer(r.data))
            .catch(() => setServer({}));
    }, []);

    const content = useMemo(() => ({ ...SITE, ...(server || {}) }), [server]);

    const save = async (data) => {
        await api.put("/content", { data });
        setServer(data);
    };

    return (
        <SiteContext.Provider value={{ content, loaded: server !== null, save }}>
            {children}
        </SiteContext.Provider>
    );
};

export const useSite = () => useContext(SiteContext);
